import { twMerge } from 'tailwind-merge';
import {
  DropdownSelectedValueStyles,
  mapSizeToTypographyVariant,
} from '../variants.style';
import { Typography } from '../../../ui';

type Props = {
  label: string;
  className?: string;
} & DropdownSelectedValueStyles;

export const DropdownSelectedValue = (props: Props) => {
  const { label, size, className } = props;

  return (
    <Typography
      as="div"
      variant={mapSizeToTypographyVariant(size)}
      weight="regular"
      className={twMerge('flex-1 text-grayscale600 text-left', className)}
    >
      {label}
    </Typography>
  );
};
